import { makeStyles } from "@material-ui/core/styles";
import Navbar from "components/Navbars/Navbar.js";
import { get } from "lodash";
import React, { useState } from "react";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { dashboardRoutes } from "routes.js";
import backgroundImg from "../../assets/images/background/home.png";
import { getUserStoredCountry } from "../../v2_actions/auth_country";
import { ContextMenuSidebar } from "./ContextMenuSideBar";
import { GallerySideBar } from "./GallerySideBar";
import { TopMenuBar } from "./TopMenuBar";

const GALLERY_DRAWER_WIDTH = 230;

const useStyles = makeStyles({
  root: {
    height: "100vh",
    overflow: "hidden",
    background: "#f0f2f5",
    padding: "8px 10px 0",
  },
  contentWrapper: {
    height: "calc(100vh - 95px)",
    display: "flex",
    overflow: 'hidden',
    borderRadius: "14px",
    boxShadow: "none",
    background: "transparent",
  },
  contentGridItem: {
    marginTop: "-7px",
    paddingLeft: "18px !important",
    marginRight: "-15px",
  },
  contentWrapperNoSidebar: {
    display: "flex",
    width: "100%",
    height: "calc(100vh - 95px)",
    overflowY: "auto",
    background: "#ffffff",
    borderRadius: "12px",
  },
  contentWrapperNoSidebarExpandedAcrossScreen: {
    width: "calc(140% + 40px)",
    height: "calc(90vh - 20px)",
    display: "flex",
    overflowY: "auto",
    overflowX: "hidden",
    marginBottom: "50px",
    borderRadius: "12px",
    background: "#ffffff",
  },
  contentWrapperWithImage: {
    backgroundImage: `url(${backgroundImg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    width: `calc(100vw - ${GALLERY_DRAWER_WIDTH}px)`,
    height: "100%",
  },
  contentWrapperWithImageNoSidebar: {
    backgroundImage: `url(${backgroundImg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    width: "100vw",
    height: "100%",
  },
  childrenWrapper: {
    width: "100%",
    display: "flex",
  },
  topMenuBarContainer: {
    backgroundColor: "#fafbfd",
    borderBottom: "1px solid #d6e2ef",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    borderRadius: "12px",
  },
  rightSideBar: {
    background: "#fff",
    paddingBottom: 0,
    border: "1px solid #d6e2ef",
    boxShadow: "0 1px 2px rgba(11,53,86,0.04)",
    marginRight: "5px",
    marginTop: "-5px",
    marginLeft: "15px",
    maxHeight: 'calc(89vh - 16px)',
    overflow: "hidden",
    borderRadius: 14,
    display: "flex",
    flexDirection: "column",
  },
  content: {},
  drawer: {
    width: GALLERY_DRAWER_WIDTH,
    flexShrink: 0,
  },
  drawerPaper: {
    width: GALLERY_DRAWER_WIDTH,
  },
  gridContainer: {
    marginTop: "10px",
    flexWrap: "nowrap",
  },
  contextMenuSidebar: {
    backgroundColor: "#fafbfd",
    borderRadius: "12px",
    height: "calc(100vh - 95px)",
    borderRight: "1px solid #d6e2ef",
    boxShadow: "2px 2px 6px rgba(0,0,0,0.08)",
    minWidth: "270px",
    maxWidth: "270px",
    flexBasis: "270px",
    marginLeft: "8px",
  },
});

export const PageLayout = ({
  title,
  gallery,
  withBackgroundImage,
  withRightSidebar,
  expandWidthAcrossScreen,
  hideViewSideBarForPhotoArt,
  hideGalleryDropdown,
  ...props
}) => {
  const classes = useStyles();
  const history = useHistory();
  const color = "blue";
  const country = getUserStoredCountry();
  const drawerWidth = useSelector((state) => state.gallery.drawWidth);
  const showContextMenu = useSelector((state) => state.user.showMenu);
  const [mobileOpen, setMobileOpen] = useState(false);

  const showSideBar = withRightSidebar != false;

  let children_wrapper_class = classes.contentWrapper;
  if (withBackgroundImage) {
    if (showSideBar) {
      children_wrapper_class = classes.contentWrapperWithImage;
    } else {
      children_wrapper_class = classes.contentWrapperWithImageNoSidebar;
    }
  } else {
    if (showSideBar) {
      children_wrapper_class = classes.contentWrapper;
    } else if (expandWidthAcrossScreen) {
      children_wrapper_class = classes.contentWrapperNoSidebarExpandedAcrossScreen;
    } else {
    children_wrapper_class = classes.contentWrapperNoSidebar;
    }
  }


  return (
    <div className={classes.root}>
      <div className={classes.topMenuBarContainer}>
        <TopMenuBar gallery={gallery} title={hideGalleryDropdown ? null : title} />
      </div>
      <Grid container spacing={2} className={classes.gridContainer}>
        <NotificationContainer />
        <Grid item className={classes.contextMenuSidebar}>
          <ContextMenuSidebar
            key="sidebar-photographer"
            routes={dashboardRoutes}
            color={color}
            theme={{ direction: "rtl" }}
            {...props}
          />
        </Grid>
        <Grid item xs className={classes.contentGridItem}>
          <div className={children_wrapper_class}>{props.children}</div>
        </Grid>
        <Grid item xs={showSideBar ? 4 : (hideGalleryDropdown ? false : 4)} xl={showSideBar ? 3 : (hideGalleryDropdown ? false : 3)}>
          {showSideBar && (
            <div id='rightSideBar' className={classes.rightSideBar}>
             <GallerySideBar
                country={country}
                hideViewSideBarForPhotoArt={ hideViewSideBarForPhotoArt }
                gallery_id={get(gallery, "id")}
             />
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
};
